import { render } from "./Section6.vue?vue&type=template&id=00755f39&scoped=true"
import script from "./Section6.vue?vue&type=script&lang=js"
export * from "./Section6.vue?vue&type=script&lang=js"

import "./Section6.vue?vue&type=style&index=0&id=00755f39&lang=scss&scoped=true"
import "./Section6.vue?vue&type=style&index=1&id=00755f39&lang=scss"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00755f39"]])

export default __exports__